import * as React from "react";
const SvgNotificationBordered = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeMiterlimit={10}
      d="M9.602 13.021A2.49 2.49 0 0 1 7.123 15.5a2.48 2.48 0 0 1-1.749-.73 2.48 2.48 0 0 1-.73-1.749M7.138.5A4.956 4.956 0 0 0 2.18 5.458V7.02c0 .506-.208 1.266-.469 1.697l-.945 1.579c-.58.975-.179 2.061.893 2.419a17.37 17.37 0 0 0 10.966 0 1.652 1.652 0 0 0 .893-2.42l-.946-1.578c-.26-.431-.468-1.198-.468-1.697V5.458C12.096 2.733 9.863.5 7.138.5Z"
    />
  </svg>
);
export default SvgNotificationBordered;
